import React from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import CategoryProductList from "./CategoryProductList";
import PartDetailNew from "../PartDetailNew";
import PartDetailUsed from "../PartDetailUsed";
import PartDetailBody from "../PartDetailBody";

const EMPTY_ARRAY = [];

/**
 * Generic Sub-Category Page Component
 * Handles dynamic sub-category routes like /catalog/4079-accessory_kit_disc_brake_pads/
 * Uses CategoryProductList to display products
 */
const SubCategoryPage = () => {
  const params = useParams();
  const location = useLocation();

  // Extract category name from URL path
  const pathSegments = location.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1] || pathSegments[pathSegments.length - 2];

  // Also check categorySlug from params
  const { categorySlug } = params;

  // Convert URL slug to readable name (e.g., "accessory_kit_disc_brake_pads" -> "Accessory Kit Disc Brake Pads")
  const categoryName = lastSegment
    ? lastSegment
      .replace(/^\d+-/, '') // Remove leading numbers and dash
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
    : "Products";

  // Get category data from location state or construct from params
  const categoryData = React.useMemo(() => location.state?.category || {
    name: categoryName,
    slug: lastSegment,
  }, [location.state?.category, categoryName, lastSegment]);

  if (lastSegment && lastSegment.startsWith('body-p-')) {
    return <PartDetailBody listingIdOverride={lastSegment.replace(/^body-p-/, '')} />;
  }

  if (categorySlug && categorySlug.startsWith('body-p-')) {
    return <PartDetailBody listingIdOverride={categorySlug.replace(/^body-p-/, '')} />;
  }

  if (lastSegment && lastSegment.startsWith('used-p-')) {
    return <PartDetailUsed listingIdOverride={lastSegment.replace(/^used-p-/, '')} />;
  }

  if (categorySlug && categorySlug.startsWith('used-p-')) {
    return <PartDetailUsed listingIdOverride={categorySlug.replace(/^used-p-/, '')} />;
  }

  // part-p-* URLs: catch-all may match before /catalog/part-p-:itemId — render B-04 detail
  if (lastSegment && lastSegment.startsWith('part-p-')) {
    return <PartDetailNew listingIdOverride={lastSegment.replace(/^part-p-/, '')} />;
  }

  if (categorySlug && categorySlug.startsWith('part-p-')) {
    return <PartDetailNew listingIdOverride={categorySlug.replace(/^part-p-/, '')} />;
  }

  // Mock products - In real app, this would be fetched based on the category
  // For now, return empty array so CategoryProductList shows "No products found"
  // This can be replaced with actual API call or product mapping
  const products = location.state?.products || EMPTY_ARRAY;

  return (
    <CategoryProductList
      categoryName={categoryData.name}
      categorySlug={categoryData.slug}
      products={products}
      defaultFilters={categoryData}
    />
  );
};

export default SubCategoryPage;

